import { NgModule }      from '@angular/core';

import { HotelResourceService } from './hotelResource.service';
import { ApiResourceModule } from '../../apiResource/apiResource.module';
import { UrlHelperModule } from "libraries/service/url-helper/url-helper.module";
import { PermissionResourceModule } from "libraries/service/resources/permission/permissionResource.module";

@NgModule({
    imports: [
        ApiResourceModule,
        UrlHelperModule,
    ],
    providers: [
        HotelResourceService,
    ]
})
export class HotelResourceModule {  }
